import MainLayout from '@/layouts/MainLayout.vue'
export default {
  path: '/energy-flow',
  component: MainLayout,
  redirect: '/energy-flow/analysis',
  meta: { module: 'energyFlow', title: '能流分析' },
  children: [
    {
      path: 'analysis',
      name: 'EnergyFlowAnalysis',
      component: () => import('@/views/energy-flow/Analysis.vue'),
      meta: { title: '能流分析' }
    },
    {
      path: 'balance',
      name: 'EnergyFlowBalance',
      component: () => import('@/views/energy-flow/Balance.vue'),
      meta: { title: '平衡校验' }
    }
  ]
}
